import React from 'react';
import LoginContext from '../context/LoginContext';
import useRedux from '../../hooks/use-redux';
import { ILoginProps } from '../../types'

interface IProps extends ILoginProps {
  children: any,
}

export default function LoginProvider({ children, ...props }: IProps) {
  const [state, dispatch] = useRedux(props);
  return (
    <LoginContext.Provider value={{ state, dispatch }}>
      { children }
    </LoginContext.Provider>
  );
}
